import { Modal, Checkbox } from 'antd'
import React, { useState } from 'react'

const TerminalInfoModal = ({ open, onClose }) => {
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const handleOk = () => {
        if (dontShowAgain) {
            localStorage.setItem('hideTerminalInfoModal', 'true');
        }
        onClose(false);
    };

    return (
        <Modal
            title="Important Information"
            open={open}
            onOk={handleOk}
            cancelButtonProps={{ style: { display: "none" } }}
            okText="I Understand"
            centered
            closable={false}
            >
            <div style={{ paddingBlock: "10px"}}>
                <ul className='info-list'>
                    <li>Sync positions from broker account for the first time when you open the Terminal.</li>
                    <li>Always open, close, and manage positions from the QuikTrade Terminal only. This will avoid position discrepancies between the broker terminal and the QuikTrade Terminal.</li>
                    <li>When single broker positions are spread across multiple strategies, it's very important to manage those positions only in QuikTrade Terminal. Closing them in broker terminal will not close them in QuikTrade Terminal.</li>
                </ul>
                <div style={{ marginTop: '20px', borderTop: '1px solid #f0f0f0', paddingTop: '15px', paddingLeft: "20px" }}>
                    <Checkbox 
                        checked={dontShowAgain} 
                        onChange={(e) => setDontShowAgain(e.target.checked)}
                    >
                        Don't show this information again
                    </Checkbox>
                </div>
            </div>
        </Modal>
    )
}

export default TerminalInfoModal